module.exports = __webpack_public_path__ + "static/media/M123ws.b89f31d1.pdf";